module.exports = __webpack_public_path__ + "319a5524ae63b87b68364013c3de6ead.svg";